import { Box, Text, Grid, GridItem, Image, Button, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Data } from '../Context/DataContext';
import ErrorPage from '../ErrorPage';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleAdd } from '../LandingPage/handeler';

const AllProduct = () => {
    const { page, total, loading, sortCategory, prod, handlePage, handlecurrProduct } = useContext(Data);
    const dispatch = useDispatch();
    let [search, setSearchParam] = useSearchParams();
    const toast = useToast()
    const Add = (item) => {
        if (handleAdd(item)){
            toast({
                title: 'Item added to cart',
                status: 'success',
                isClosable: true,
            })
        } else{
            toast({
                title: 'Item is already in cart',
                status: 'error',
                isClosable: true,
            })
        }
    }

    const navigate = useNavigate();
    const handleProductDetail = (productDetails) => {
        handlecurrProduct(productDetails)
        navigate(`/products/${productDetails.id}`)
    }
    useEffect(() => {
        setSearchParam({ page: page })
    }, [page])


    const { error } = useSelector((state) => state);
    return loading ? <Box h="100vh" opacity="0.5" w="100wh" pos={"relative"}>
        <Image pos={"absolute"} top="15%" left="40%" m="100px auto" bgColor={"transparent"} src="https://i.ibb.co/CvKFMhq/loading.gif" />
    </Box> :
        error ? <ErrorPage /> :
            (
                <>
                    <Box p={"15px"} bgColor="#ffffff" borderRadius={"10px"} >
                        <Text fontSize={"13px"} fontWeight='700' color={"rgba(21,27,57,.6)"} letterSpacing="1px" textTransform={"uppercase"} mb="10px">All Product</Text>
                        <Grid templateColumns={{ base: "repeat(2,1fr)", lg: "repeat(4,1fr)" }} gap="13px">
                            {prod.map((el) => {
                                const { title, id, img1, actual_price, net_price,crossed_price, manufacturer, category, sub_category, moq, stock_available, stockText, discount } = el;
                                // const discount = Math.round(((crossed_price - actual_price) / crossed_price) * 100);
                                return <GridItem key={id} w="100%" p={'14px 16px 15px 16px'} border='solid 1px rgba(112,112,112,.38)' borderRadius={"8px"} position="relative">
                                    {crossed_price && <Text as='span' position={"absolute"} bg="#84be52" fontSize={"9px"} lineHeight="11px" p="4px 5px 2px 5px" borderRadius={"4px"} color="white" top="8px" left="8px">CD UPTO:{discount} %</Text>}
                                    <Image h={'150px'} objectFit="cover" margin={"0 auto"} src={img1 ? img1 : "https://i.ibb.co/SnT9yQq/SORRY-NO-IMAGE-FOUND.gif"} cursor="pointer" />
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb="5px">
                                   <Text mt="5px" overflow={"hidden"} fontSize={"14px"} fontWeight={"700"} h={"42px"} color="#151b39" cursor="pointer" >{title}</Text>
                                   <Box display="flex" alignItems="center" justifyContent="center" bg="#ffa500" borderRadius="4px" p="4px 8px" fontSize="10px" fontWeight="bold" color="#fff" >
                                         MOQ : {moq}
                                         
                                    </Box>
                                </Box>

                                    {/* <Box overflow={"hidden"} h='30px' w="100%" mt="5px" >
                                        <Text as="span" color={"#5e17eb"} fontSize="10px" borderRadius={"40px"} mr="4px" p='4px 10px' bgColor={"#f3f7fb"}>{category}</Text>
                                        <Text as="span" color={"#5e17eb"} fontSize="10px" borderRadius={"40px"} mr="4px" p='4px 10px' w="max-content" bgColor={"#f3f7fb"}>{sub_category}</Text>
                                    </Box> */}
                                    <Text w="auto" fontStyle={"italic"} lineHeight="16px" color={'#6f7284'} fontSize="13px" m="5px 0">Mfg: {manufacturer}</Text>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Text fontSize={"14px"} color="#247F52">InStock {stockText}:</Text> {/* Display Stock Available or Qty Available */}
                                    <Text fontSize={"14px"} color="#" fontWeight={"700"}> {stock_available !== undefined ? stock_available : "AVAILABLE"} </Text> {/* Display stock or 100 if not available */}
                                    </Box>
                                    <Text fontSize={"14px"} color="#6f7284" fontWeight={"700"}>PTR* <Text as='span' fontSize="16px" color="#ef4281">₹{actual_price}</Text></Text>
                                    <Box h="40px">
                                        {crossed_price && <Text fontSize={"13px"} padding="5px 0" color="#6f7284">MRP<Text as="span" textDecor={"line-through"} p="0 5px">Rs.{crossed_price}</Text></Text>}
                                    </Box>
                                    <Button w="100%" bgColor={"#5e17eb"} color="white" textTransform={"uppercase"} _hover={{ bgColor: "#000", color: "white" }} onClick={() => {
                                        Add(el)
                                    }} >Add to cart</Button>
                                    
                                </GridItem >
                            })}
                        </Grid>
                        {total >= 20 && <Box textAlign={"center"} mt="30px" display="flex" gap='5px' justifyContent={"center"}>
                            {page !== 1 && <Button size={"sm"} border="1px solid #d4d5d9" bgColor="white" p="0 20px" fontWeight={"400"} _hover={{ color: '#0298a7', bgColor: 'white' }} fontSize={"13px"} color="#151b39" onClick={() => handlePage(page - 1)}>PREV</Button>}
                            {<Button onClick={(e) => handlePage(+e.target.innerHTML)} size={"sm"} _hover={{ color: '#0298a7', bgColor: '#D4D5D940' }} bgColor="white" fontWeight={"400"} fontSize={"13px"} color="#151b39">{page}</Button>}
                            {page !== Math.ceil(total / 20) && <Button size={"sm"} border="1px solid #d4d5d9" bgColor="white" p="0 20px" fontWeight={"400"} _hover={{ color: '#0298a7', bgColor: 'white' }} fontSize={"13px"} color="#151b39" onClick={() => handlePage(page + 1)}>NEXT</Button>}
                        </Box>}
                    </Box>
                </>
            )
}

export default AllProduct